var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F5FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4839_19330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12C24.4183 12 28 15.5817 28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12ZM20 13.5C16.4101 13.5 13.5 16.4101 13.5 20C13.5 23.5899 16.4101 26.5 20 26.5C23.5899 26.5 26.5 23.5899 26.5 20C26.5 16.4101 23.5899 13.5 20 13.5ZM22.3478 21.6776C22.5886 21.3405 23.057 21.2625 23.3941 21.5033C23.7311 21.7441 23.8091 22.2125 23.5683 22.5495C23.4279 22.7461 23.2708 22.9316 23.0979 23.1045C21.3849 24.8175 18.6076 24.8175 16.8947 23.1045C16.722 22.9318 16.565 22.7466 16.4247 22.5503C16.1839 22.2133 16.2618 21.7449 16.5988 21.504C16.9358 21.2631 17.4042 21.3411 17.6451 21.678C17.7374 21.8073 17.841 21.9295 17.9553 22.0438C19.0825 23.171 20.9101 23.171 22.0372 22.0438C22.1517 21.9294 22.2554 21.807 22.3478 21.6776ZM17.375 17.2527C17.9963 17.2527 18.5 17.7564 18.5 18.3777C18.5 18.999 17.9963 19.5027 17.375 19.5027C16.7537 19.5027 16.25 18.999 16.25 18.3777C16.25 17.7564 16.7537 17.2527 17.375 17.2527ZM22.62 17.2527C23.2413 17.2527 23.75 17.7564 23.75 18.3777C23.75 18.999 23.2463 19.5027 22.625 19.5027C22.0037 19.5027 21.5 18.999 21.5 18.3777C21.5 17.7564 21.9987 17.2527 22.62 17.2527Z",
    fill: "#99A2AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4839_19330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6425f98cd1fc3e5c2d64a275e446f753.svg";
export { ForwardRef as ReactComponent };